import { Grid, Tab, Tabs, Typography } from "@mui/material";
import type { FC } from "react";
import { Link as RouterLink, Outlet, useLocation } from "react-router-dom";
import type { AdminProductOptionResponse } from "../productsApi";

interface Props {
  readonly productId: string;
  readonly provider: {
    readonly id: string;
    readonly useDynamicPrices: boolean;
    readonly computePricesFromPurchasePrice: boolean;
  };
  readonly options: AdminProductOptionResponse[];
}

const routes = ["edit-single", "edit-many", "convert", "order"];

const ProductOptions: FC<Props> = ({ productId, provider, options }) => {
  const location = useLocation();
  const mode = location.pathname.split("/")[4] ?? routes[0];
  return (
    <Grid container spacing={1}>
      <Grid size={12}>
        <Typography variant="h6">Opcje</Typography>
      </Grid>
      <Grid size={12}>
        <Tabs value={mode} centered>
          <Tab label="Edytuj jedną" value={routes[0]} component={RouterLink} to={routes[0]} />
          <Tab label="Edytuj wiele" value={routes[1]} component={RouterLink} to={routes[1]} />
          <Tab label="Przelicz" value={routes[2]} component={RouterLink} to={routes[2]} />
          <Tab label="Kolejność" value={routes[3]} component={RouterLink} to={routes[3]} />
        </Tabs>
      </Grid>
      <Grid size={12}>
        <Outlet context={{ productId, provider, options }} />
      </Grid>
    </Grid>
  );
};

export default ProductOptions;
